import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import * as React from 'react';
import * as PropTypes from 'prop-types';
import ModalDialog from '../_shared/ModalDialog';
import { useKeyDown } from '../_shared/hooks/useKeyDown';
export var ModalWrapper = function ModalWrapper(_ref) {
  var open = _ref.open,
    children = _ref.children,
    okLabel = _ref.okLabel,
    cancelLabel = _ref.cancelLabel,
    clearLabel = _ref.clearLabel,
    todayLabel = _ref.todayLabel,
    showTodayButton = _ref.showTodayButton,
    clearable = _ref.clearable,
    DialogProps = _ref.DialogProps,
    showTabs = _ref.showTabs,
    wider = _ref.wider,
    InputComponent = _ref.InputComponent,
    DateInputProps = _ref.DateInputProps,
    onClear = _ref.onClear,
    onAccept = _ref.onAccept,
    onDismiss = _ref.onDismiss,
    onSetToday = _ref.onSetToday,
    other = _objectWithoutProperties(_ref, ["open", "children", "okLabel", "cancelLabel", "clearLabel", "todayLabel", "showTodayButton", "clearable", "DialogProps", "showTabs", "wider", "InputComponent", "DateInputProps", "onClear", "onAccept", "onDismiss", "onSetToday"]);
  useKeyDown(open, {
    Enter: onAccept
  });
  return React.createElement(React.Fragment, null, React.createElement(InputComponent, _extends({}, other, DateInputProps)), React.createElement(ModalDialog, _extends({
    wider: wider,
    showTabs: showTabs,
    open: open,
    onClear: onClear,
    onAccept: onAccept,
    onDismiss: onDismiss,
    onSetToday: onSetToday,
    clearLabel: clearLabel,
    todayLabel: todayLabel,
    okLabel: okLabel,
    cancelLabel: cancelLabel,
    clearable: clearable,
    showTodayButton: showTodayButton,
    children: children
  }, DialogProps)));
};
process.env.NODE_ENV !== "production" ? ModalWrapper.propTypes = {
  okLabel: PropTypes.node,
  cancelLabel: PropTypes.node,
  clearLabel: PropTypes.node,
  clearable: PropTypes.bool,
  todayLabel: PropTypes.node,
  showTodayButton: PropTypes.bool,
  DialogProps: PropTypes.object
} : void 0;
ModalWrapper.defaultProps = {
  okLabel: 'OK',
  cancelLabel: 'Cancel',
  clearLabel: 'Clear',
  todayLabel: 'Today',
  clearable: false,
  showTodayButton: false
};